import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import {
  Footer,
  Header,
  TryEdworking,
  EdworkingPromotion,
  SolutionCompare,
  OurClients,
  Testimonials,
  TaskFeatures,
  FeaturesIntro,
  TopBanner,
} from '../../js/components'
import { SERVER_URL, validateEmail, newLive } from '../../js'
import Link from 'next/link'
import Image from 'next/image'
import { OrganizationSchema, WebPageSchema, BreadcrumbListSchema } from '../../js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks

export async function getStaticPaths({ locales }) {
  const array = locales.map((locale) => {
    return [
      { locale, params: { solution: 'freelancers' } },
      { locale, params: { solution: 'smallteams' } },
      { locale, params: { solution: 'startups' } },
      { locale, params: { solution: 'project-management' } },
      { locale, params: { solution: 'remote-work' } },
      { locale, params: { solution: 'team-collaboration' } },
      { locale, params: { solution: 'agile-management' } },
    ]
  })
  return {
    paths: array.flat(1),
    fallback: false,
  }
}

export async function getStaticProps({ locale, locales, params }) {
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'solutions.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  return {
    props: { content, ...params, locale, locales },
  }
}
export default function Solution({ content, solution, locale, locales }) {
  const [promotion, setPromotion] = useState(false)

  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }

  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema
        name={content.solutions[solution].title}
        description={content.solutions[solution].description}
      />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Solutions',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}solutions`,
          },
          {
            name: solution,
            url: `https://edworking.com/${
              locale !== 'en' ? `${locale}/` : ''
            }solutions/${solution}`,
          },
        ]}
      />
      <Head>
        <title>{content.solutions[solution].title}</title>
        <meta itemProp="name" content={`${content.solutions[solution].title}`} />
        <meta itemProp="description" content={content.solutions[solution].description} />
        <meta name="description" content={content.solutions[solution].description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${
              locale1 !== 'en' ? `/${locale1}` : ''
            }/solutions/${solution}`}
          />
        ))}
        <link
          rel="alternate"
          href={`https://edworking.com/solutions/${solution}`}
          hrefLang="x-default"
        />
        <link
          rel="canonical"
          href={`https://edworking.com/${
            locale !== 'en' ? `${locale}/` : ''
          }solutions/${solution}`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header clean content={content.header} topbanner={true} />
      <SolutionCompare content={content.solutions[solution]} />
      <OurClients content={content.customers} />
      <Highlights content={content.solutions[solution]} />
      <FeaturesIntro content={content.solutions[solution].introsolutions} />
      <TaskFeatures content={content.solutions[solution]} />
      <BannerEd content={content.bannered} />
      <Testimonials content={content.reviews} />
      <TryEdworking content={content.endbanner} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}

const BannerEd = ({ content }) => {
  return (
    <section className="banner bannered">
      <Image
        className="image"
        width="150"
        height="150"
        src="https://storage.googleapis.com/dratini/Edworking%20Logo.png"
        alt=""
      />
      <div className="text">
        <div className="subheadline">{content.slogan}</div>
      </div>
      <a className="blueButton" href="https://app.edworking.com/signup/user/">
        {content.button}
      </a>
    </section>
  )
}
const Highlights = ({ content }) => {
  return (
    <div className="highlights">
      {content.benefits.map((strength, index) => (
        <div key={index} className="highlight">
          <Image width={25} height={25} src={strength.img} alt="" />
          <span>{strength.title}</span>
          <p>{strength.description}</p>
        </div>
      ))}
    </div>
  )
}

const SummaryTask = ({ content }) => {
  const [expand, setExpand] = useState(0)
  return (
    <section className="feature" id="chat">
      <h2 className="title">{content.slogan2}</h2>
      <h2 className="description">{content.description2}</h2>
      <div className="benefits-feature">
        <div className="listbox">
          {content.benefits.map((benefit, index) => (
            <div
              key={index}
              className="info"
              id="listbox1"
              style={{
                height: expand === index ? 'fit-content' : 'fit-content',
              }}
              onClick={() => setExpand(index)}
            >
              <Image
                width={11}
                height={7}
                className="arrow"
                src="/images/features/RightArrowBlack.svg"
                alt="Arrow"
                style={{ rotate: expand === index ? '90deg' : '270deg' }}
              />
              <span>{benefit.title}</span>
              <p
                style={{
                  opacity: expand === index ? 1 : 0,
                  display: expand === index ? 'flex' : 'none',
                }}
              >
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
        <div className="image general">
          <Image
            width={500}
            height={250}
            style={{ display: expand === 0 ? 'flex' : 'none', height: 'auto' }}
            src={content.benefits[0].img}
            alt="Project Management"
          />
          <Image
            width={500}
            height={250}
            style={{ display: expand === 1 ? 'flex' : 'none', height: 'auto' }}
            src={content.benefits[1].img}
            alt="Project Management"
          />
          <Image
            width={500}
            height={250}
            style={{ display: expand === 2 ? 'flex' : 'none', height: 'auto' }}
            src={content.benefits[2].img}
            alt="Project Management"
          />
        </div>
      </div>
    </section>
  )
}

const IntroFeature = ({ content, basics }) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState({ email: false })

  const submit = () => {
    if (email === '') {
      setError({ email: true })
      newLive('/images/Logo.svg', 'Enter ', 'a valid email')
    } else if (!validateEmail(email)) {
      setError({ email: true })
      newLive('/images/Logo.svg', email, ' is an invalid email')
    } else {
      fetch(SERVER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          operationName: 'NewUserPromotion',
          query:
            'mutation NewUserPromotion($email: String!, $promotion: Int) {newUserPromotion(email: $email, promotion: $promotion){ id }}',
          variables: { email: email, promotion: 4 },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.errors) {
            newLive('/images/Logo.svg', email, ' is already registered')
          } else {
            window.location = `https://app.edworking.com/signup/user/u/${res.data.newUserPromotion.id}`
          }
          setEmail('')
        })
        .catch((e) => newLive('/images/Logo.svg', email, ' is already registered'))
    }
  }

  return (
    <section className="import intro">
      <div className="column" style={{ width: '40%', zIndex: 2 }}>
        <h1 className="title">{content.title2}</h1>
        <h2 className="description">{content.description}</h2>
        <input
          type="text"
          style={{
            border: error.email
              ? '1px solid rgb(255, 148, 171)'
              : '1px solid rgba(223, 228, 229, 0.658824)',
          }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="textInput"
          placeholder={basics.inputEmail}
        />
        <div style={{ display: 'flex', margin: '20px 0' }}>
          <div className="blueButton" style={{ width: 220 }} onClick={() => submit()}>
            Get Started Now
          </div>
          <Link href="https://live.edworking.com/" className="demo">
            <Image
              width={25}
              height={25}
              style={{ opacity: 0.45, height: 25 }}
              src="/images/play.png"
              alt="Front Platform"
            />
            {basics.demo}
          </Link>
        </div>
      </div>
      <div className="column" style={{ width: '60%' }}>
        <video
          preload="none"
          muted
          loop
          autoPlay
          className="video"
          src="https://storage.googleapis.com/dratini/VideoRecording/UIAnimation.mp4"
          alt="Task Management"
        />
      </div>
    </section>
  )
}
